import React, { useId, useRef } from 'react';
import './SuccessModal.css';
import useModalErisim from '../../hooks/useModalErisim';

export default function SuccessModal({
  isOpen = false,
  title,
  message,
  onClose,
  onConfirm,
  onCloseText,
  onConfirmText
}) {
  // FE-80: dialog rolü, Esc = kapat (dış alana tıklamakla aynı), Tab döngüsü, odak geri.
  const pencereRef = useRef(null);
  const baslikId = useId();
  useModalErisim(isOpen, pencereRef, onClose || onConfirm, true);
  if (!isOpen) return null;

  // Tek buton gösterildiğinde o buton YEŞİL (confirm) stiliyle çıkar; iptal/kapat gibi ikincil
  // butonlar yalnız birden fazla buton varken gri (cancel) kalır. (WarningModal ile AYNI kural —
  // SuccessModal bu kuralı uygulamadığı için yalnız onCloseText veren ekranlar beyaz buton
  // alıyordu.) Kural bileşende durur; çağıran metni hangi prop'a verdiğini düşünmek zorunda değil.
  const buttonCount = [onCloseText, onConfirmText].filter(Boolean).length;
  const closeVariant = buttonCount === 1 ? "confirm" : "cancel";

  const handleOverlayMouseDown = (event) => {
    if (event.target === event.currentTarget) {
      (onClose || onConfirm)?.();
    }
  };

  return (
    <div className="modal-overlay" onMouseDown={handleOverlayMouseDown}>
      <div className="success-modal" ref={pencereRef} role="dialog" aria-modal="true" tabIndex={-1} aria-labelledby={baslikId}>
        <div className="success-modal__icon-wrapper">
          <svg
            className="success-modal__icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="11" fill="none" stroke="currentColor" strokeWidth="2" />
            <path d="M7 13l3 3 7-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2 className="success-modal__title" id={baslikId}>{title}</h2>
        <p className="success-modal__message">{message}</p>
        <div className="success-modal__actions">
          {onCloseText &&
            <button
              className={`success-modal__button success-modal__button--${closeVariant}`}
              onClick={onClose}
            >
              {onCloseText}
            </button>
          }

          {onConfirmText &&
            <button
              className="success-modal__button success-modal__button--confirm"
              onClick={onConfirm}
            >
              {onConfirmText}
            </button>
          }

        </div>
      </div>
    </div>
  );
}
